module.exports = __webpack_public_path__ + "assets/img/liulan1.50d31c2c.png";